import React from "react";
import { useLocation } from "react-router-dom";
import Logo from "../../assets/logo.png";
import dashboard from "../../assets/dashboard.png";
import dashboardWhite from "../../assets/dashboardWhite.png";
import NewQuotes from "../../assets/NewQuotes.png";
import WhiteNewQuotes from "../../assets/WhiteNewQuotes.png";
import MyQuotes from "../../assets/MyQuotes.png";
import WhiteMyQuotes from "../../assets/WhiteMyQuotes.png";
import NewRequest from "../../assets/NewRequest.png";
import WhiteNewRequest from "../../assets/WhiteNewRequest.png";
import MyShipments from "../../assets/MyShipments.png";
import WhiteMyShipments from "../../assets/WhiteMyShipments.png";
import Tracking from "../../assets/Tracking.png";
import WhiteTracking from "../../assets/WhiteTracking.png";
import IOR from "../../assets/IOR.png";
import trackwhite from "../../assets/trackwhite.png";
import invoiceWhite from "../../assets/invoiceWhite.png";
import ShipmentHistory from "../../assets/ShipmentHistory.png";
import WhiteShipmentHistory from "../../assets/WhiteShipmentHistory.png";
import supportTicketWhite from "../../assets/support-ticket-white.png";
import icon1 from "../../assets/invoice.png";
import icon2 from "../../assets/support-ticket.png";

const TourSidebar = ({ isTourActive = false, currentStep, tourSteps }) => {
  const location = useLocation();
  // Early return AFTER the hook
  if (!isTourActive) return null;
  const getActivePath = () => {
    const currentTourStep = tourSteps?.[currentStep];
    if (currentTourStep?.path === "/bookshipment") {
      return "/bookshipment";
    }
    return location.pathname;
  };
  const activePath = getActivePath();

  const items = [
    { content: "Dashboard",        src: dashboard,         activeSrc: dashboardWhite,        path: "/dashboard" },
    { content: "New Quotes",       src: NewQuotes,         activeSrc: WhiteNewQuotes,        path: "/newquotes" },
    { content: "My Quotes",        src: MyQuotes,          activeSrc: WhiteMyQuotes,         path: "/myqoutes" },
    { content: "New Request",      src: NewRequest,        activeSrc: WhiteNewRequest,       path: "/bookshipment" },
    { content: "My Shipments",     src: MyShipments,       activeSrc: WhiteMyShipments,      path: "/myShipment" },
    { content: "Tracking",         src: Tracking,          activeSrc: WhiteTracking,         path: "/trackshipment" },
    { content: "TradeOS",          src: IOR,               activeSrc: trackwhite,            path: "/oneunion-trade-os" },
    { content: "HS Compass",       src: IOR,               activeSrc: trackwhite,            path: "/hs-compass" },
    { content: "Invoices",         src: icon1,             activeSrc: invoiceWhite,          path: "/invoices" },
    { content: "Shipment History", src: ShipmentHistory,   activeSrc: WhiteShipmentHistory,  path: "/shipmenthistory" },
    { content: "Support & Help",   src: icon2,             activeSrc: supportTicketWhite,    path: "/support&help" },
  ];

  return (
    <>
      <div className="fixed inset-0 bg-black/30 z-40 pointer-events-none" aria-hidden="true" />

      {/* Tour Sidebar – fixed, on top, scales nicely on 150%+ displays */}
      <div
        className="
          fixed left-0 top-0 h-full bg-white shadow-2xl z-50
          w-56
          [@media(min-resolution:144dpi)]:w-48
          [@media(min-resolution:144dpi)]:scale-92
          [@media(min-resolution:192dpi)]:scale-86
          origin-top-left transition-all duration-300
        "
      >
      {/* Logo */}
        <div className="grid place-items-center py-6">
          <img className="w-32" src={Logo} alt="One Union Solutions" />
        </div>

      {/* Navigation */}
        <ul className="px-3 space-y-1">
          {items.map((item) => {
            const isActive = activePath === item.path;

            return (
              <li key={item.path}>
                <div
                  data-tour-id={item.path.slice(1)}
                  className={`
                    flex items-center gap-3 px-4 py-3 rounded-lg cursor-default
                    transition-all duration-300
                    ${isActive 
                      ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg" 
                      : "text-gray-600 hover:bg-gray-100"
                    }
                  `}
                >
                  <img
                    className={`
                      w-6 h-6 flex-shrink-0
                      [@media(min-resolution:144dpi)]:w-5 [@media(min-resolution:144dpi)]:h-5
                    `}
                    src={isActive ? item.activeSrc : item.src}
                    alt={item.content}
                  />
                  <span
                    className={`
                      text-sm font-medium
                      [@media(min-resolution:144dpi)]:text-xs
                      ${!isActive && "text-gray-500"}
                    `}
                  >
                    {item.content}
                  </span>
                </div>
              {/* Active glow */}
              {isActive && (
                <div className="absolute inset-0 -m-1 bg-white/10 rounded-lg z-15" />
              )}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default TourSidebar;